// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__19kIy","buttons":"PendingPaymentAlert_buttons__242u1"};